export default __webpack_public_path__ + "static/media/p4-5.eb3a0f75.png";